import { Select } from "@dashboard/components/Select";
import { type ChannelFragment } from "@dashboard/graphql";
import { type ChannelProps } from "@dashboard/types";
import { mapNodeToChoice } from "@dashboard/utils/maps";
import { Box } from "@saleor/macaw-ui-next";

interface AppChannelSelectProps extends ChannelProps {
  channels: ChannelFragment[];
  onChannelSelect: (id: string) => void;
}

const AppChannelSelect = ({
  channels,
  onChannelSelect,
  selectedChannelId,
}: AppChannelSelectProps) => {
  return (
    <Box display="flex" alignItems="center">
      <Select
        __width={130}
        __height={28}
        // 글자가 위로 4px 떠 있던 것 바로잡기 (2026-09-21 KST 추가).
        // 줄높이는 20px 인데 위 __height 로 상자만 28px 라, 남는 8px 이 전부 아래에
        // 몰려 오른쪽 화살표보다 높이 앉았다. 줄높이는 Text 가 제 요소에 직접 박아
        // 물려줄 수 없어서, 줄을 늘리는 대신 상자 안에서 가운데로 세운다.
        alignItems="center"
        data-test-id="app-channel-select"
        size="large"
        onChange={({ target }) => onChannelSelect(target.value)}
        value={selectedChannelId}
        options={mapNodeToChoice(channels)}
      />
    </Box>
  );
};

AppChannelSelect.displayName = "AppChannelSelect";
export default AppChannelSelect;
